import { renovationDescriptionsByLoanSubtype as _temp } from '@roc/feature-utils';

export const renovationDescriptionsByLoanSubtype = _temp;
